export default __webpack_public_path__ + "static/media/ben.52b16059.jpg";